import React, { memo, useState } from "react";

// Speaking Zone
import ReadAloud from "components/Question/Speaking/New/ReadAloud.jsx";
import RetellLec from "components/Question/Speaking/New/RetellLec.jsx";
import ShortQue from "components/Question/Speaking/New/ShortQue.jsx";

// Writing Zone
import Summary from "components/Question/Writting/Summary.jsx";
import Essay from "components/Question/Writting/Essay.jsx";

// Reading Zone
import SingleAnswer from "components/Question/Reading/SingleAnswer.jsx";
import MultipleAnswer from "components/Question/Reading/MultipleAnswer.jsx";
import Reorder from "components/Question/Reading/Reorder1.jsx";
import ReadingBlank from "components/Question/Reading/ReadingBlank.jsx";
import WritingBlank from "components/Question/Reading/WrittingBlank.jsx";

// Listening Zone
import Summer from "components/Question/Listening/Summer.jsx";
import McqSingle from "components/Question/Listening/McqSingle.jsx";
import McqMulti from "components/Question/Listening/McqMulti.jsx";
import ListeningBlank from "components/Question/Listening/ListeningBlank.jsx";
import MissingWord from "components/Question/Listening/MissingWord.jsx";
import CorrectSummary from "components/Question/Listening/CorrectSummary.jsx";
import Dictation from "components/Question/Listening/Dictation.jsx";
import Highlight from "components/Question/Listening/Highlight.jsx";
import RepeatSentece from "components/Question/Speaking/New/RepeatSentece";
import DescribeImage from "components/Question/Speaking/New/DescribeImage";
import SummarizeGroupDiscussion from "components/Question/Speaking/New/SummarizeGroupDiscussion";
import RespondToSituation from "components/Question/Speaking/New/RespondToSituation";

// export deafult function LoadQuestionType({
const LoadQuestionType = memo(function LoadQuestionType({
	queProps, subcategoryId, languages, option_explaination, key, submitDisable
}) {
	const Question = () => {
		// Return null if no data is available
		if (!queProps.data) {
			return <div>Loading question data...</div>;
		}

		let q;

		// console.log("subcategoryid",subcategoryId);
		

		switch (subcategoryId) {
			case 1:
				q = (
					<ReadAloud
						key={key}
						languages={languages}
						{...queProps}
					/>
				);
				break;
			case 2:
				q = (
					<RepeatSentece
						key={key}
						{...queProps}
					/>
				);
				break;
			case 3:
				q = (
					<DescribeImage
						key={key}
						{...queProps}
					/>
				);
				break;
			case 4:
				q = (
					<RetellLec
						key={key}
						{...queProps}
					/>
				);
				break;
			case 5:
				q = (
					<ShortQue
						key={key}
						{...queProps}
					/>
				);
				break;
			case 6:
				q = (
					<Summary
						key={key}
						{...queProps}
						submitDisable={submitDisable}
					/>
				);
				break;
			case 7:
				q = (
					<Essay
						key={key}
						{...queProps}
						submitDisable={submitDisable}
					/>
				);
				break;
			case 8:
				q = (
					<SingleAnswer
						key={key}
						{...queProps}
					/>
				);
				break;
			case 9:
				q = (
					<MultipleAnswer
						key={key}
						{...queProps}
					/>
				);
				break;
			case 10:
				q = (
					<Reorder
						key={key}
						{...queProps}
						submitDisable={submitDisable}
					/>
				);
				break;
			case 11:
				q = (
					<ReadingBlank
						key={key}
						languages={languages}
						option_explaination={option_explaination}
						{...queProps}
						submitDisable={submitDisable}
					/>
				);
				break;
			case 12:
				q = (
					<WritingBlank
						key={key}
						languages={languages}
						option_explaination={option_explaination}
						{...queProps}
						submitDisable={submitDisable}
					/>
				);
				break;
			case 13:
				q = (
					<Summer
						key={key}
						{...queProps}
						submitDisable={submitDisable}
					/>
				);
				break;
			case 14:
				q = (
					<McqSingle
						key={key}
						{...queProps}
					/>
				);
				break;
			case 15:
				q = (
					<McqMulti
						key={key}
						{...queProps}
					/>
				);
				break;
			case 16:
				q = (
					<ListeningBlank
						key={key}
						{...queProps}
					/>
				);
				break;
			case 17:
				q = (
					<CorrectSummary
						key={key}
						{...queProps}
					/>
				);
				break;
			case 18:
				q = (
					<MissingWord
						key={key}
						{...queProps}
					/>
				);
				break;
			case 19:
				q = (
					<Highlight
						key={key}
						{...queProps}
					/>
				);
				break;
			case 20:
				q = (
					<Dictation
						key={key}
						{...queProps}
						submitDisable={submitDisable}
					/>
				);
				break;
                case 21:
				q = (
					<RespondToSituation
						key={key}
						{...queProps}
					/>
				);
				break;
			    case 22:
				q = (
					<SummarizeGroupDiscussion
						key={key}
						{...queProps}
					/>
				);
				break;
				}

		return q;
	}

	return Question();
});

export default LoadQuestionType;
